module.exports = __webpack_public_path__ + "img/ttncreateapp3.faf65efc.png";